import React, { Component } from 'react';
import { APP_CONST } from '../../../../../../constants';
import { GeckoFields, GeckoBtn, Spinner } from '../../../../../../components';
import './style.css';


export class Manage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Software: false,
            SMS: false,
            preferred: props.default,
            unsavedChanges: false,
            ...props.preferences,
        }

        this.submit = this.submit.bind(this);
    }

    handleChange(name, evt) {
        this.setState({[name]: evt, unsavedChanges: true});
    }

    fields()
    {
        return [{
            label: 'Authenticator App',
            key: 'Software',
            disabledWhen: () => false,
            type: APP_CONST.FIELD_TYPE_TOGGLE,
        }, {
            label: 'SMS',
            key: 'SMS',
            disabledWhen: () => false,
            type: APP_CONST.FIELD_TYPE_TOGGLE,
        }];
    }

    renderSelect() {
        let disabled = false;
        let disabledSoftware = false;
        let disabledSMS = false;

        if (!this.state.Software && !this.state.SMS) {
            disabled = true;
        }

        if (!this.state.Software) {
            disabledSoftware = true;
        }

        if (!this.state.SMS) {
            disabledSMS = true;
        }

        return (
            <div style={{padding: '15px'}}>
                <label for="preferred" className="preferredLabel">Preferred Method</label>
                <select name="preferred" className="preferedMfaMethod" disabled={disabled} value={this.state.preferred} onChange={(event) => this.handleChange('preferred', event.target.value)}>
                    <option value="none">No Preference</option>
                    <option disabled={disabledSoftware} value="SOFTWARE">Authenticator App</option>
                    <option disabled={disabledSMS} value="SMS">SMS</option>
                </select>
            </div>
        )
    }

    submit() {
        let preferred = this.state.preferred;
        
        if (!this.state.Software && !this.state.SMS) {
            preferred = null;
        }

        if (preferred === 'none') {
            preferred = null;
        }

        return this.props.updatePreferences(this.state.SMS, this.state.Software, preferred);
    }

    render() {
        return (
            <div>
                <div className="mfaConfirmationFieldContainer">
                    <GeckoFields 
                        fields={this.fields()}
                        values={this.state}
                        handler={this.handleChange.bind(this)}
                        submitHandler={() => {}} 
                    />

                    {this.renderSelect()}

                    <GeckoBtn 
                        name={'Update'}
                        icon={'save'}
                        type={APP_CONST.BTN_TYPE_SUCCESS}
                        className={'float-right '}
                        hideWhen={() => !this.state.unsavedChanges}
                        handler={this.submit} 
                    />
                </div>
                
            </div>
        )
    }
}

Manage.defaultProps = {
    updatePreferences: () => null,
    default: null,
    preferences: {},
}

export default Manage;